window.showJsAlert = function(message, duration = 4000) {
  const stack = document.querySelector(".popup-notification-stack");

  if (!stack) {
    pushUploadEvent("photo_upload_warning", {
      phase: "popup_notification_missing",
      warningMessage: "popup-notification-stack not found",
    });
    return;
  }

  const notification = document.createElement("div");
  notification.className = "popup-notification";
  notification.innerHTML = message;
  notification.style.display = "flex";
  stack.appendChild(notification);

  const removeNotification = () => {
    notification.remove();
  };

  notification.querySelector("svg")?.addEventListener("click", (event) => {
    event.stopPropagation();
    removeNotification();
  });

  setTimeout(() => {
    removeNotification();
  }, duration);
};

// Reuse existing popup style to show upload failures with file names.
function showUploadFailedAlert(fileNames) {
  const sanitizedNames = (fileNames || [])
    .filter(Boolean)
    .map((name) => String(name).trim())
    .filter(Boolean);

  if (!sanitizedNames.length) return;

  const failedList = sanitizedNames
    .map((name) => `<b class="bold">${escapeUploadHtml(name)}</b>`)
    .join(", ");

  const message = getUploadTranslation("uploadFailed", "Upload failed for: __FILES__. Please try again.")
    .replace("__FILES__", failedList);

  showJsAlert(`
    <span class="body-text">
      ${message}
    </span>
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25.4558 8.48528L8.48523 25.4558" stroke="#3C1F1B" stroke-width="3" stroke-linecap="round"/>
      <path d="M8.48533 8.48528L25.4559 25.4558" stroke="#3C1F1B" stroke-width="3" stroke-linecap="round"/>
    </svg>
  `);
}

function showValidationAlert(message) {
  showJsAlert(`
    <span class="body-text">${message}</span>
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25.4558 8.48528L8.48523 25.4558" stroke="#3C1F1B" stroke-width="3" stroke-linecap="round"/>
      <path d="M8.48533 8.48528L25.4559 25.4558" stroke="#3C1F1B" stroke-width="3" stroke-linecap="round"/>
    </svg>
  `);
}

document.querySelectorAll(".tab-section__content").forEach((block) => {
  block.addEventListener("click", function (e) {
    const blockId = this.dataset.blockId;
    const currentCount = store[blockId]?.length || 0;

    if (activeUploadBlockIds.has(blockId) || currentCount >= MAX_FILES_PER_BLOCK) {
      e.preventDefault();
      e.stopImmediatePropagation(); 

      const input = this.querySelector(".native-uploader");
      if (input) input.blur(); 

      if (activeUploadBlockIds.has(blockId)) return false;

      this.classList.add("disabled-upload");

      showJsAlert(`
        <span class="body-text">
          ${getUploadTranslation("uploadLimit", `The upload limit is <b>${MAX_FILES_PER_BLOCK} photos per upload</b> window. Additional files will not be accepted.`)}
        </span>
        <svg width="34" height="34" viewBox="0 0 34 34">
          <path d="M25 8L8 25" stroke="#3C1F1B" stroke-width="3"/>
          <path d="M8 8L25 25" stroke="#3C1F1B" stroke-width="3"/>
        </svg>
      `);

      return false;
    }
  });
});

// Helpers
function hideElements(selector) {
  document.querySelectorAll(selector).forEach((el) => {
    el.style.display = "none";
  });
}

function toggleClass(element, className) {
  if (element) element.classList.toggle(className);
}

// General Cart Add
function postCartData(formData) {
  const startedAt = Date.now();
  const routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  const cartContext = {
    phase: "cart_add",
    productId: productID,
    productType,
    variantId: variantID,
    collectionId: currentCollectionID,
    propertyCount: formData?.items?.[0]?.properties
      ? Object.keys(formData.items[0].properties).length
      : 0,
  };

  const cartPayload = { ...formData };
  try {
    if (window.LegitGrails?.analytics?.allowed?.("analytics")) {
      const ph = window.posthog;
      const distinctId = ph?.has_opted_out_capturing?.()
        ? null
        : ph?.get_distinct_id?.();
      if (typeof distinctId === "string" && distinctId.length > 0) {
        cartPayload.attributes = { ...formData.attributes, _posthog_distinct_id: distinctId };
      }
    }
  } catch (error) {
    // Optional analytics must not block cart submission.
  }

  return fetch(routesRoot + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(cartPayload),
  })
    .then((response) => {
      if (!response.ok) {
        return response.text().then((body) => {
          const error = new Error(`[uploadPhoto] cart/add.js failed with status ${response.status}`);
          error.status = response.status;
          error.responseText = body;
          throw error;
        });
      }

      return response.json();
    })
    .then(() => {
      // Redirect to checkout or do something else
      window.document.location.href = `${routesRoot}cart/checkout`;
    })
    .catch((error) => {
      pushUploadError(error, {
        ...cartContext,
        ...extractErrorContext(error),
        durationMs: Date.now() - startedAt,
      });
    });
}

/* DIALOG */
const formDialog = document.querySelector(".popup-container-u");
const overlay = document.querySelector(".popup-overlay-u");
const ANIMATION_TIME = 350;
const tabs = document.querySelector(".tabs-u");

/*
  openDialogButtons refers to "Upload Photo" buttons used on article pages,
  etc. On other pages, typically only one button is present.
*/
const openDialogButtons = document.querySelectorAll(".authenticate-btn");

function initOpenDialogButtons() {
  if (!tabs) return;
  document.querySelectorAll(".authenticate-btn").forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      if (!overlay || !formDialog) {
        const error = new Error("[uploadPhotoInit] Upload dialog elements are missing");
        pushUploadError(error, {
          phase: "init_dialog_open_failed",
          productId: productID,
          productType,
          variantId: variantID,
          hasOverlay: Boolean(overlay),
          hasFormDialog: Boolean(formDialog),
          ...extractErrorContext(error),
        });
        return;
      }
      window.LegitGrails?.analytics?.capture?.('sh_uploading_form_open');
      overlay.classList.remove("hidden");
      overlay.classList.add("open");
      setTimeout(() => formDialog.classList.remove("transparent"), 200);
      const activeTab = tabs.querySelector(".tab-active");
      if (activeTab) {
        tabs.style.height = `${activeTab.clientHeight}px`;
      }
      document.body.classList.add("popup-page");
    });
  });
}

function closeDialog() {
  if (!formDialog && !overlay) return;
  formDialog.classList.add("transparent");
  overlay.classList.add("hiding");

  setTimeout(() => {
    document.body.classList.remove("popup-page");
    overlay.classList.remove("hiding", "open");
    overlay.classList.add("hidden");
  }, ANIMATION_TIME);
}

function cloneAndUpdateForm(form, container, index) {
  let formClone = form.cloneNode(true);
  formClone.classList.add(`product-card__${index}`);
  formClone.querySelectorAll("[id^='radio_']").forEach((el) => {
    const newId = `${el.id}_${index}`;
    el.id = newId;
    el.parentElement.setAttribute("for", newId);
  });
  container.appendChild(formClone);
}

function setFormStyles(isFormCart) {
  if (isFormCart) {
    document.querySelectorAll(".photo-upload-widget").forEach((el) => {
      el.style.order = "6";
    });
    hideElements(".custom-cart-button");
    hideElements(".product_card-btns");
    hideElements(".product_checkout-btns");
  }

  if (document.body.classList.contains("template-article")) {
    const form = document.querySelector("#product-card-container .product-card");
    document.querySelectorAll(".product-box").forEach((el, index) => {
      cloneAndUpdateForm(form, el, index);
    });
  }
}

function setPresets(tags) {
  // We no longer sort by tags: categories appear in the order
  // they come from the JSON / generated HTML.

  const typeInputs = Array.from(document.querySelectorAll("input[name='types']"));
  if (!typeInputs.length) return;

  // Uncheck all categories first
  typeInputs.forEach((input) => {
    input.checked = false;
  });

  // Make the first category from the file/DOM the active one
  const firstInput = typeInputs[0];
  firstInput.checked = true;

  // Update global state and UI to match
  currentCollectionID = firstInput.id;
  switchTabs(currentCollectionID);
}

function updateTabAndTip(tab) {
  toggleClass(document.querySelector(".tab-active"), "tab-active");
  toggleClass(document.getElementById(`tab-${tab}`), "tab-active");
  toggleClass(document.querySelector(".tip-active"), "tip-active");
  toggleClass(document.getElementById(`tip-${tab}`), "tip-active");
}

// Update Step 2 Subtitle. Shoes substring has an exception.
// function updateStepSubtitle(tab) {
//   const titles = {
//     "other-shoes-luxury": "shoes",
//     "other-shoes-hype": "shoes",
//   };
//   document.getElementById("collection-title").innerText =
//     titles[tab] || tab.replace("-", " ");
// }

function switchTabs(tab) {
  updateTabAndTip(tab);
  document.querySelector(".tabs").style.height =
    document.querySelector(".tab-active").clientHeight + "px";
  // updateStepSubtitle(tab);

  document.querySelectorAll(".uploaded").forEach((block) => {
    block.classList.remove("uploaded");
    block.querySelector(".tab-section__counter").innerHTML = "";
  });
}

function getRequiredUploadElement(selector, context) {
  const element = document.querySelector(selector);
  if (element) return element;

  const error = new Error(`[uploadPhotoInit] Missing required element: ${selector}`);
  pushUploadError(error, {
    phase: "init_required_element_missing",
    selector,
    ...context,
    ...extractErrorContext(error),
  });
  throw error;
}

function getRequiredUploadElementById(id, context) {
  const element = document.getElementById(id);
  if (element) return element;

  const error = new Error(`[uploadPhotoInit] Missing required element: #${id}`);
  pushUploadError(error, {
    phase: "init_required_element_missing",
    elementId: id,
    ...context,
    ...extractErrorContext(error),
  });
  throw error;
}

function getRequiredUploadText(element, fieldName, context) {
  const value = String(element?.textContent || "").trim();
  if (value) return value;

  const error = new Error(`[uploadPhotoInit] Missing required value: ${fieldName}`);
  pushUploadError(error, {
    phase: "init_required_value_missing",
    fieldName,
    ...context,
    ...extractErrorContext(error),
  });
  throw error;
}

function parseUploadProductData(container) {
  try {
    return JSON.parse(container.dataset.product || "{}");
  } catch (error) {
    pushUploadError(error, {
      phase: "init_product_data_parse",
      hasProductDataset: Boolean(container.dataset.product),
      ...extractErrorContext(error),
    });
    throw error;
  }
}

function runUploadInitStep(stepName, callback, context) {
  try {
    return callback();
  } catch (error) {
    pushUploadError(error, {
      phase: "init_step",
      initStep: stepName,
      ...context,
      ...extractErrorContext(error),
    });
    throw error;
  }
}

const dataProductContainer = getRequiredUploadElement(".photo-upload-product-hidden", {
  initStep: "product_data_container",
});
const productData = parseUploadProductData(dataProductContainer);
const productDataElement = getRequiredUploadElementById("product-data", {
  initStep: "product_id",
});
const productUploadsElement = getRequiredUploadElementById("product-uploads", {
  initStep: "product_uploads",
});
const selectedVariantElement = document.getElementById("selected-variant");

const productID = getRequiredUploadText(productDataElement, "productID", {
  initStep: "product_id",
});
const productType = productUploadsElement.dataset.type || "";
const sessionStorageKey = "photo_upload_" + productID;
const uploaderContainer = getRequiredUploadElement(".photo-upload-attributes", {
  initStep: "uploader_container",
  productId: productID,
});
const uploadSubmit = document.getElementById("upload_submit");
const photoUploadCartButton = document.getElementById("photo-upload-cart");
const FILES_UPLOADS_ENDPOINT = resolveFilesUploadsEndpoint();
const UPLOADS_PUBLIC_BASE_URL = resolveUploadsPublicBaseUrl();
const MAX_UPLOAD_FILE_SIZE_BYTES = 100 * 1024 * 1024;
const MAX_FILES_PER_BLOCK = 3;
const ALLOWED_IMAGE_EXTENSIONS = new Set([
  "jpg", "jpeg", "png", "gif", "webp", "avif", "bmp", "tif", "tiff", "heic", "heif",
]);
const TUS_RETRY_DELAYS_MS = [0, 3000, 5000, 10000, 20000];
const UPLOAD_TELEMETRY_DOMAIN = "photo_upload";

function resolveInitialVariantId(selectedVariantInput, product, productId) {
  const inputVariantId = String(selectedVariantInput?.value || "").trim();
  if (inputVariantId) return inputVariantId;

  const variants = Array.isArray(product?.variants) ? product.variants : [];
  const fallbackVariant = variants.find((variant) => variant && variant.id);
  const fallbackVariantId = String(fallbackVariant?.id || "").trim();

  if (fallbackVariantId) {
    pushUploadEvent("photo_upload_warning", {
      phase: "selected_variant_input_missing",
      warningMessage: "#selected-variant input is missing; using the first product variant",
      productId,
      variantId: fallbackVariantId,
      variantsCount: variants.length,
    });
    return fallbackVariantId;
  }

  const error = new Error("[uploadPhotoInit] Missing selected variant fallback");
  pushUploadError(error, {
    phase: "selected_variant_data_missing",
    productId,
    variantsCount: variants.length,
    ...extractErrorContext(error),
  });
  throw error;
}

function showInvalidFileTypeAlert(fileNames) {
  const invalidList = fileNames
    .map((name) => `<b class="bold">${escapeUploadHtml(name)}</b>`)
    .join(", ");
  const message = getUploadTranslation(
    "invalidFileType",
    "Unsupported image files: __FILES__. Supported formats: JPEG, PNG, GIF, WebP, AVIF, BMP, TIFF, HEIC and HEIF.",
  ).replace("__FILES__", invalidList);

  showValidationAlert(message);
}

function showFileTooLargeAlert(fileNames) {
  const fileList = fileNames
    .map((name) => `<b class="bold">${escapeUploadHtml(name)}</b>`)
    .join(", ");
  const message = getUploadTranslation(
    "fileTooLarge",
    "Files larger than 100 MB were not accepted: __FILES__.",
  ).replace("__FILES__", fileList);

  showValidationAlert(message);
}

function getUploadTranslation(key, fallback) {
  return productUploadsElement?.dataset?.[key] || fallback;
}

function escapeUploadHtml(value) {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

let formIsValid = false;
let store = {}; // { "bag_sole": [ 'uuid1','uuid2' ], "bag_insole": [...], etc. }
let currentCollectionID = document.querySelector("input[name='types']:checked")
  ? document.querySelector("input[name='types']:checked").id
  : null;
let isFormCart = productUploadsElement.classList.contains("form-cart");
let variantID = resolveInitialVariantId(selectedVariantElement, productData, productID);

/**
 * Returns the shared telemetry bridge for upload-form instrumentation.
 *
 * @returns {object|null}
 */
function getUploadTelemetry() {
  return window.LegitGrails && window.LegitGrails.telemetryBridge
    ? window.LegitGrails.telemetryBridge
    : null;
}

/**
 * Creates a per-upload identifier through the shared telemetry bridge.
 *
 * @param {string} prefix
 * @returns {string}
 */
function createTelemetryId(prefix) {
  const telemetry = getUploadTelemetry();
  if (telemetry && typeof telemetry.createId === "function") {
    return telemetry.createId(prefix);
  }

  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}

function getFileExtension(file) {
  const name = String(file?.name || "");
  const dotIndex = name.lastIndexOf(".");
  if (dotIndex === -1 || dotIndex === name.length - 1) return "";
  return name.slice(dotIndex + 1).toLowerCase().slice(0, 12);
}

function getFileSizeBucket(file) {
  const size = Number(file?.size || 0);
  const mb = 1024 * 1024;

  if (size <= mb) return "0-1MB";
  if (size <= 5 * mb) return "1-5MB";
  if (size <= 20 * mb) return "5-20MB";
  if (size <= MAX_UPLOAD_FILE_SIZE_BYTES) return "20-100MB";
  return "100MB+";
}

function getUrlParts(value) {
  try {
    const parsed = new URL(value, window.location.origin);
    return {
      endpointHost: parsed.host,
      endpointPath: parsed.pathname,
    };
  } catch (error) {
    return {
      endpointHost: "",
      endpointPath: "",
    };
  }
}

function buildUploadTelemetryContext(extra) {
  const endpoint = getUrlParts(FILES_UPLOADS_ENDPOINT);

  return {
    productId: productID,
    productType,
    variantId: variantID,
    collectionId: currentCollectionID,
    sessionStorageKey,
    endpointHost: endpoint.endpointHost,
    endpointPath: endpoint.endpointPath,
    ...extra,
  };
}

function buildFileTelemetryContext(file, extra) {
  return buildUploadTelemetryContext({
    fileType: file?.type || "application/octet-stream",
    fileExtension: getFileExtension(file),
    fileSizeBucket: getFileSizeBucket(file),
    ...extra,
  });
}

/**
 * Sends a photo-upload event through the shared telemetry bridge.
 *
 * The bridge queues the event until the deferred Faro runtime is ready.
 *
 * @param {string} name
 * @param {object} context
 * @returns {void}
 */
function pushUploadEvent(name, context) {
  try {
    const telemetry = getUploadTelemetry();
    if (!telemetry || typeof telemetry.pushEvent !== "function") return;
    telemetry.pushEvent(name, context, UPLOAD_TELEMETRY_DOMAIN);
  } catch (error) {
    // Telemetry must never break the upload form.
  }
}

/**
 * Sends a photo-upload exception through the shared telemetry bridge.
 *
 * @param {*} error
 * @param {object} context
 * @returns {void}
 */
function pushUploadError(error, context) {
  try {
    const telemetry = getUploadTelemetry();
    if (!telemetry || typeof telemetry.pushError !== "function") return;
    telemetry.pushError(error, context);
  } catch (telemetryError) {
    // Telemetry must never break the upload form.
  }
}

/**
 * Extracts serializable error fields for Faro context.
 *
 * @param {*} error
 * @returns {object}
 */
function extractErrorContext(error) {
  const context = {
    errorName: error?.name || "Error",
    errorMessage: error?.message || String(error || ""),
    errorCode: error?.code || "",
  };

  const originalResponse = error?.originalResponse;
  if (originalResponse) {
    if (typeof originalResponse.getStatus === "function") {
      context.serverStatus = originalResponse.getStatus();
    } else if (Number.isFinite(originalResponse.status)) {
      context.serverStatus = originalResponse.status;
    }

    if (typeof originalResponse.getBody === "function") {
      context.serverResponseText = originalResponse.getBody();
    } else if (typeof originalResponse.responseText === "string") {
      context.serverResponseText = originalResponse.responseText;
    }
  }

  if (Number.isFinite(error?.status)) {
    context.serverStatus = error.status;
  }

  if (typeof error?.responseText === "string") {
    context.serverResponseText = error.responseText;
  }

  return context;
}

function ensureTrailingSlash(value) {
  const normalized = String(value || "").trim();
  if (!normalized) return "";
  return normalized.endsWith("/") ? normalized : `${normalized}/`;
}

function resolveFilesUploadsEndpoint() {
  // Allow forcing a specific endpoint from theme/global scripts.
  if (window.LG_FILES_UPLOADS_ENDPOINT) {
    return ensureTrailingSlash(window.LG_FILES_UPLOADS_ENDPOINT);
  }

  // Backward-compatible override alias.
  if (window.LG_FILE_UPLOADS_ENDPOINT) {
    return ensureTrailingSlash(window.LG_FILE_UPLOADS_ENDPOINT);
  }

  // Compatibility with old variable name, but only if it already points to files service.
  if (
    window.LG_FILE_UPLOADS_API_URL &&
    String(window.LG_FILE_UPLOADS_API_URL)
      .toLowerCase()
      .includes("files.legitgrails.com")
  ) {
    return ensureTrailingSlash(window.LG_FILE_UPLOADS_API_URL);
  }

  return "https://files.legitgrails.com/";
}

function resolveUploadsPublicBaseUrl() {
  // Optional override to keep integration contract aligned with backend infra.
  if (window.LG_UPLOADS_PUBLIC_BASE_URL) {
    return ensureTrailingSlash(window.LG_UPLOADS_PUBLIC_BASE_URL);
  }

  // Default public media URL for tusd objects.
  return "https://media.legitgrails.com/uploads/tusd/";
}

function ensureTusClientLoaded() {
  return Boolean(window.tus && typeof window.tus.Upload === "function");
}

function isUploadSizeAllowed(file) {
  if (!file || !Number.isFinite(file.size)) return true;
  return file.size <= MAX_UPLOAD_FILE_SIZE_BYTES;
}

function isAllowedImageFile(file) {
  if (!file) return false;
  const extension = String(file.name || "").split(".").pop().toLowerCase();
  return ALLOWED_IMAGE_EXTENSIONS.has(extension);
}

function buildTusMetadata(file, blockId) {
  const metadata = {
    filename: file.name || `photo-${Date.now()}`,
    filetype: file.type || "application/octet-stream",
    product_id: String(productID || ""),
    block_id: String(blockId || ""),
  };

  if (currentCollectionID) {
    metadata.collection_id = String(currentCollectionID);
  }

  if (productType) {
    metadata.product_type = String(productType);
  }

  return metadata;
}

function mapTusUploadUrlToPublicPhotoUrl(uploadUrl) {
  if (!uploadUrl) return uploadUrl;

  try {
    const parsed = new URL(uploadUrl);
    const tusResource = parsed.pathname.split("/").pop() || "";
    const uploadId = tusResource.split("+")[0];

    if (!uploadId) {
      return uploadUrl;
    }

    return `${UPLOADS_PUBLIC_BASE_URL}${uploadId}`;
  } catch (error) {
    return uploadUrl;
  }
}

async function uploadPhotoViaTus(file, blockId, telemetryContext) {
  let trackedUpload = null;
  const startedAt = Date.now();
  const baseContext = buildFileTelemetryContext(file, {
    ...telemetryContext,
    blockId,
  });

  return new Promise((resolve, reject) => {
    if (!ensureTusClientLoaded()) {
      const error = new Error("[uploadPhoto] tus-js-client is not loaded");
      pushUploadError(error, {
        ...baseContext,
        phase: "tus_client_missing",
      });
      reject(error);
      return;
    }

    const upload = new window.tus.Upload(file, {
      endpoint: FILES_UPLOADS_ENDPOINT,
      retryDelays: TUS_RETRY_DELAYS_MS,
      metadata: buildTusMetadata(file, blockId),
      onError(error) {
        activeTusUploads.delete(upload);
        const uploadError = error || new Error("[uploadPhoto] tus upload failed");
        pushUploadError(uploadError, {
          ...baseContext,
          ...extractErrorContext(uploadError),
          phase: "tus_upload",
          durationMs: Date.now() - startedAt,
        });
        reject(uploadError);
      },
      onSuccess() {
        activeTusUploads.delete(upload);
        const rawUploadUrl = upload.url || "";
        const publicPhotoUrl = mapTusUploadUrlToPublicPhotoUrl(rawUploadUrl);
        resolve(publicPhotoUrl);
      },
    });

    trackedUpload = upload;
    activeTusUploads.add(upload);

    upload
      .findPreviousUploads()
      .then((previousUploads) => {
        if (previousUploads.length > 0) {
          upload.resumeFromPreviousUpload(previousUploads[0]);
        }

        upload.start();
      })
      .catch((error) => {
        activeTusUploads.delete(upload);
        pushUploadError(error, {
          ...baseContext,
          ...extractErrorContext(error),
          phase: "find_previous_uploads",
          durationMs: Date.now() - startedAt,
        });
        reject(error);
      });
  }).finally(() => {
    if (trackedUpload) {
      activeTusUploads.delete(trackedUpload);
    }
  });
}

function isAbortError(error) {
  // Ignore user-initiated cancellation noise in UI/logging paths.
  if (!error) return false;
  return (
    error.name === "AbortError" ||
    error.code === "ABORT_ERR" ||
    String(error.message || "").toLowerCase().includes("aborted")
  );
}

runUploadInitStep("set_form_styles", () => setFormStyles(isFormCart), {
  productId: productID,
  productType,
  variantId: variantID,
});
runUploadInitStep("set_presets", () => setPresets(productData.tags || []), {
  productId: productID,
  productType,
  variantId: variantID,
});

/* Keep track of active tus uploads so we can cancel them if needed */
const activeTusUploads = new Set();
const activeUploadBlockIds = new Set();

/*
  Step 1 radio-switch logic (switching between "bag", "shoes", etc.)
*/
function handleInputChange(event) {
  event.stopPropagation();

  cancelAllUploads(); // Cancels everything in flight
  resetUploaderData(); // Also clears store, resets states

  currentCollectionID = event.target.id;
  formIsValid = false;
  switchTabs(currentCollectionID);
}

/**
 * Cancel all current uploads.
 */
function cancelAllUploads() {
  Array.from(activeTusUploads).forEach((upload) => {
    try {
      upload.abort();
    } catch (error) {
      pushUploadError(error, {
        phase: "cancel_all_uploads",
        productId: productID,
        productType,
        variantId: variantID,
        collectionId: currentCollectionID,
      });
      activeTusUploads.delete(upload);
    }
    activeTusUploads.delete(upload);
  });
}

// Attach the "change" listener for radio inputs
document.querySelectorAll("input[name='types']").forEach((input) => {
  if (input.checked) {
    switchTabs(input.id);
    resetUploaderData();
    currentCollectionID = input.id;
  }
  input.addEventListener("change", handleInputChange);
});

/************************************/
/* 1) Attach event listeners to new native file inputs */
/************************************/

document.querySelectorAll(".native-uploader").forEach((inputEl) => {
  inputEl.addEventListener("change", handleFileInputChange);
});

/**********************************************
 * 2) The main handler for uploading multiple files
 **********************************************/
async function handleFileInputChange(event) {
  const input = event.currentTarget;
  const blockId = input.dataset.blockId; // e.g. "bag_sole" or "bag_insole"
  const blockEl = document.getElementById(blockId);
  const selectedFiles = Array.from(input.files || []);
  const uploadBatchId = createTelemetryId("upload_batch");
  const batchStartedAt = Date.now();

  if (!selectedFiles.length) {
    input.value = "";
    return;
  }

  if (activeUploadBlockIds.has(blockId)) {
    input.value = "";
    return;
  }

  activeUploadBlockIds.add(blockId);
  input.disabled = true;
  if (blockEl) {
    blockEl.classList.add("uploading");
    const loaderLine = blockEl.querySelector(".loader-line");
    if (loaderLine) loaderLine.classList.add("visible");
  }

  try {
    // Merge persisted state before calculating the available slots.
    setCurrentUuids();

    const existingCount = store[blockId]?.length || 0;
    const availableSlots = Math.max(0, MAX_FILES_PER_BLOCK - existingCount);
    const acceptedFiles = [];
    const invalidFileNames = [];
    const oversizedFileNames = [];
    let limitReached = false;

    // Validate in the exact order supplied by the input. Once all slots are
    // reserved, remaining files are deliberately left uninspected.
    for (const file of selectedFiles) {
      if (acceptedFiles.length >= availableSlots) {
        limitReached = true;
        break;
      }

      if (!isAllowedImageFile(file)) {
        invalidFileNames.push(file.name);
        continue;
      }

      if (!isUploadSizeAllowed(file)) {
        oversizedFileNames.push(file.name);
        continue;
      }

      acceptedFiles.push(file);
    }

    if (invalidFileNames.length) showInvalidFileTypeAlert(invalidFileNames);
    if (oversizedFileNames.length) showFileTooLargeAlert(oversizedFileNames);
    if (limitReached) {
      showValidationAlert(getUploadTranslation(
        "uploadLimit",
        `The upload limit is <b>${MAX_FILES_PER_BLOCK} photos per upload</b> window. Additional files will not be accepted.`,
      ));
    }

    if (!acceptedFiles.length) return;

    const selectedCount = acceptedFiles.length;
    const uploadResults = acceptedFiles.map((file) => ({
      status: "error",
      fileName: file.name,
      error: null,
      url: null,
    }));

    try {
      await Promise.all(
        acceptedFiles.map(async (file, idx) => {
          const uploadAttemptId = createTelemetryId("upload_attempt");
          const fileContext = {
            uploadBatchId,
            uploadAttemptId,
            blockId,
            fileCountInBatch: selectedCount,
          };

          try {
            const uploadedFileUrl = await uploadPhotoViaTus(file, blockId, fileContext);
            uploadResults[idx] = {
              status: "success",
              fileName: file.name,
              error: null,
              url: uploadedFileUrl,
            };
          } catch (error) {
            uploadResults[idx] = {
              status: isAbortError(error) ? "aborted" : "error",
              fileName: file.name,
              error,
              url: null,
            };
          }
        }),
      );

      const successfulUrls = uploadResults
        .filter((item) => item.status === "success" && item.url)
        .map((item) => item.url);
      const failedFileNames = uploadResults
        .filter((item) => item.status === "error")
        .map((item) => item.fileName);

      if (failedFileNames.length) showUploadFailedAlert(failedFileNames);

      if (!store[blockId]) store[blockId] = [];
      store[blockId] = [...store[blockId], ...successfulUrls.filter(Boolean)];
    } catch (anyError) {
      if (!isAbortError(anyError)) {
        showUploadFailedAlert(acceptedFiles.map((file) => file.name));
        pushUploadError(anyError, {
          ...buildUploadTelemetryContext({
            uploadBatchId,
            blockId,
            fileCountInBatch: selectedCount,
            ...extractErrorContext(anyError),
            phase: "batch_exception",
            durationMs: Date.now() - batchStartedAt,
          }),
        });
      }
    }

    saveSessionData();
    updateRequiredFields();
    validateForm();
    setCartProperties();
  } finally {
    activeUploadBlockIds.delete(blockId);
    input.disabled = false;
    input.value = "";

    if (blockEl) {
      blockEl.classList.remove("uploading");
      const loaderLine = blockEl.querySelector(".loader-line");
      if (loaderLine) loaderLine.classList.remove("visible");
    }
  }
}


/**
 * Refactored setCurrentUuids Function
 * 
 * Instead of replacing the entire `store`, we'll ensure that we're merging updates safely.
 */
function setCurrentUuids() {
  const storedData = sessionStorage.getItem(sessionStorageKey);
  if (storedData !== null) {
    try {
      const uploadSessionData = JSON.parse(storedData);
      if (uploadSessionData.store && typeof uploadSessionData.store === 'object') {
        // Merge the existing store with the stored data
        store = { ...store, ...uploadSessionData.store };
      }
    } catch (error) {
      pushUploadError(error, {
        phase: "session_storage_parse",
        sessionStorageKey,
        productId: productID,
        productType,
        collectionId: currentCollectionID,
        ...extractErrorContext(error),
      });
      // If parsing fails, consider clearing the store to avoid inconsistencies
      store = {};
    }
  }
}

// Coalesce frequent calls and always persist the latest in-memory state.
let saveSessionScheduled = false;
let saveSessionDirty = false;
const scheduleMicrotask =
  typeof queueMicrotask === "function"
    ? queueMicrotask
    : (callback) => Promise.resolve().then(callback);

function saveSessionData() {
  saveSessionDirty = true;

  if (saveSessionScheduled) {
    return;
  }

  saveSessionScheduled = true;

  scheduleMicrotask(() => {
    saveSessionScheduled = false;
    if (!saveSessionDirty) return;

    saveSessionDirty = false;

    const uploadSessionData = {
      form: sessionStorageKey,
      store: { ...store },
      collection: currentCollectionID,
    };

    try {
      sessionStorage.setItem(sessionStorageKey, JSON.stringify(uploadSessionData));
    } catch (error) {
      pushUploadError(error, {
        phase: "session_storage_save",
        sessionStorageKey,
        productId: productID,
        productType,
        collectionId: currentCollectionID,
        ...extractErrorContext(error),
      });
    }

    if (saveSessionDirty) {
      saveSessionData();
    }
  });
}

function updateRequiredFields() {
  const MAX_FILES_PER_BLOCK = 3;

  Object.keys(store).forEach((key) => {
    const counterID = `counter-tab-${key}`;
    const counterElement = document.getElementById(counterID);
    const tabElement = document.getElementById(key);
    const count = store[key].length || 0;

    if (counterElement) {
      counterElement.innerText = count || "";
    }

    if (tabElement) {
      if (count > 0) {
        tabElement.classList.add("uploaded");
      } else {
        tabElement.classList.remove("uploaded");
      }

      if (count === MAX_FILES_PER_BLOCK) {
        tabElement.classList.add("uploaded--all");
      } else {
        tabElement.classList.remove("uploaded--all");
      }
    }
  });
}


function validateForm() {
  formIsValid = true;
  // Grab the currently active tab's required blocks:
  let currentTab = document.getElementById(`tab-${currentCollectionID}`);
  if (!currentTab) return;

  let requiredBlocks = currentTab.querySelectorAll(".item-required");
  requiredBlocks.forEach((el) => {
    if (!el.classList.contains("uploaded")) {
      formIsValid = false;
    }
  });
}

function setCartProperties() {
  if (!formIsValid) return;

  // 1) Clear existing hidden inputs first
  if (uploaderContainer) {
    uploaderContainer.innerHTML = "";
  }

  // 2) Insert _Category
  const collectionValue = productType
    ? `${currentCollectionID}-${productType}`
    : currentCollectionID;

  createAndAppendInput(
  "properties[_Category]",
  `property-${currentCollectionID}`,
  collectionValue
);

  // 3) For each block in `store`, build hidden inputs, remove "currentCollectionID" part from the key
  Object.keys(store).forEach((blockId) => {
    if (store[blockId].length > 0) {
      let i = 1;
      store[blockId].forEach((photoUrl) => {
        // E.g. blockId = "sneakers-hype_overall-picture"
        // We remove "sneakers-hype" or "bag" etc. from the front:
        // (Feel free to adjust the exact string logic if your blockId differs)
        let propertyName = blockId.replace(`${currentCollectionID}_`, "");

        // => "_overall-picture_1"
        // If you want that exact style, do:
        propertyName = `_${propertyName}_${i}`;

        // Now create a hidden input with that name
        createAndAppendInput(
          `properties[${propertyName}]`,
          `${blockId}-${i}`,    // as the <input id=...> so it’s unique
          photoUrl
        );
        i++;
      });
    }
  });

  updateButtonStates(false, "Uploaded");
}

function createAndAppendInput(name, id, value) {
  if (!uploaderContainer) return;

  const safeId = `${id}--${productID}`; // make unique per product instance
  if (!uploaderContainer.querySelector(`#${CSS.escape(safeId)}`)) {
    const input = document.createElement("input");
    input.name = name;
    input.id = safeId;
    input.value = value;
    input.type = "hidden";
    uploaderContainer.appendChild(input);
  }
}

function updateButtonStates(isDisabled, text) {
  const action = isDisabled ? "add" : "remove";
  if (isFormCart) {
    if (photoUploadCartButton) {
      photoUploadCartButton.classList[action]("disabled");
    }
  } else {
    if (uploadSubmit) {
      uploadSubmit.classList[action]("disabled");
    }
  }
  openDialogButtons.forEach((btn) => (btn.innerText = text));
}

function resetUploaderData() {
  // Clear store and session
  formIsValid = false;
  store = {};
  sessionStorage.removeItem(sessionStorageKey);

  if (isFormCart && photoUploadCartButton) {
    photoUploadCartButton.classList.add("disabled");
  } else if (uploadSubmit) {
    uploadSubmit.classList.add("disabled");
  }
}

// Close popup
const popupCloseButton = document.querySelector(".popup-btn__close");
if (popupCloseButton) {
  popupCloseButton.addEventListener("click", () => {
    closeDialog();
  });
} else {
  pushUploadEvent("photo_upload_warning", {
    phase: "popup_close_button_missing",
    warningMessage: "popup-btn__close not found",
    productId: productID,
    productType,
    variantId: variantID,
  });
}

// Update variantID
const productForms = Array.from(
  document.getElementsByClassName("product-form"),
);

if (!document.querySelector(".option-container")) {
  productForms.forEach((form) => {
    form.addEventListener("change", (event) => {
      variantID = String(event.target.value || "").trim();
    });
  });
}

// Non-cart submission just closes popup:
if (!isFormCart && uploadSubmit) {
  uploadSubmit.addEventListener("click", () => {
    // If you'd like to do a final check:
    // if(formIsValid) { ... } else { ... }
    closeDialog();
  });
}

// For form-cart submission:
function prepareLineItemProperties(variantID) {
  const properties = {};

  const inputs = uploaderContainer.querySelectorAll(
    'input[name^="properties["]'
  );

  if (!inputs.length) {
    throw new Error("No upload properties found");
  }

  inputs.forEach((input) => {
    const name = input.name.match(/\[(.*?)\]/)[1];
    properties[name] = input.value;
  });

  return {
    items: [{ id: variantID, quantity: 1, properties }],
  };
}


function setVariantIDmultiplyOptions() {
  if (!document.querySelector(".option-container")) {
    return true;
  }

  const selectedOptionsElement = document.getElementById(
    "selected-options-values--" + productID
  );

  if (!selectedOptionsElement || !selectedOptionsElement.dataset.variant) {
    const error = new Error("[uploadPhoto] selected options variant is missing");
    pushUploadError(error, {
      phase: "selected_options_variant_missing",
      productId: productID,
      productType,
      currentVariantId: variantID,
      collectionId: currentCollectionID,
      hasSelectedOptionsElement: Boolean(selectedOptionsElement),
      ...extractErrorContext(error),
    });
    return false;
  }

  variantID = String(selectedOptionsElement.dataset.variant || "").trim();
  return true;
}

// DataLayer example usage:
let cartPrice = "";
let cartTime = "";
let cartTitle = "";

window.dataLayer = window.dataLayer || [];

async function addToCart() {
  if (!setVariantIDmultiplyOptions()) {
    showValidationAlert(getUploadTranslation("checkoutUnavailable", "Unable to prepare checkout. Please refresh the page and try again."));
    return;
  }

  let formData;

  try {
    formData = prepareLineItemProperties(variantID);

    const props = formData.items[0].properties;
    if (!props || Object.keys(props).length === 0) {
      throw new Error("Empty properties");
    }
  } catch (e) {
    pushUploadError(e, {
      phase: "prepare_cart_properties",
      productId: productID,
      productType,
      variantId: variantID,
      collectionId: currentCollectionID,
      ...extractErrorContext(e),
    });
    showValidationAlert(getUploadTranslation("uploadRequired", "Upload required photos before checkout"));
    return;
  }

  // For Google Tag
  const productVariants = Array.isArray(productData.variants)
    ? productData.variants
    : [];
  let selectedVariantData = productVariants.find(
    (variant) => variant.id == variantID
  );

  if (!selectedVariantData) {
    const error = new Error("[uploadPhoto] Selected variant data not found");
    pushUploadError(error, {
      phase: "selected_variant_data_missing",
      productId: productID,
      productType,
      variantId: variantID,
      collectionId: currentCollectionID,
      variantsCount: productVariants.length,
      ...extractErrorContext(error),
    });
    showValidationAlert(getUploadTranslation("checkoutUnavailable", "Unable to prepare checkout. Please refresh the page and try again."));
    return;
  }

  cartPrice = selectedVariantData.price / 100;
  cartTime = selectedVariantData.public_title;
  cartTitle = selectedVariantData.name;

  window.LegitGrails?.analytics?.capture?.('sh_uploading_form_submit', {
      sh_order_product: productData.title,
      sh_order_product_Id: productData.id,
      sh_order_product_price: cartPrice,
      sh_order_answer_time: parseInt(cartTime).toString()
  })

  // WARNING: Legacy analytics contract: "purchase" is emitted before cart/add.js succeeds.
  // This is a submission attempt, not a confirmed purchase. Keep the event name
  // and transaction_id (variantID) unchanged unless existing analytics is migrated.
  window.LegitGrails?.analytics?.track?.("purchase", {
    ecommerce: {
      transaction_id: variantID,
      value: cartPrice,
      currency: Shopify.currency.active,
      items: [
        {
          item_name: cartTitle,
          item_id: variantID,
          price: cartPrice,
          item_variant: cartTime,
        },
      ],
    },
  });

  postCartData(formData);
}

function isUploadInProgress() {
  return activeTusUploads.size > 0;
}

function getMissingRequiredUploadBlocks() {
  const currentTab = document.getElementById(`tab-${currentCollectionID}`);
  if (!currentTab) return ["__current_tab_missing__"];

  const missingBlocks = [];
  const requiredBlocks = currentTab.querySelectorAll(".item-required");

  requiredBlocks.forEach((el) => {
    const blockId = el.dataset.blockId;
    if (!store[blockId] || store[blockId].length === 0) {
      missingBlocks.push(blockId || "__missing_block_id__");
    }
  });

  return missingBlocks;
}

function validateFormStrict() {
  return getMissingRequiredUploadBlocks().length === 0;
}

if (isFormCart && photoUploadCartButton) {
  photoUploadCartButton.addEventListener("click", async (event) => {
    event.preventDefault();

    if (isUploadInProgress()) {
      const error = new Error("[uploadPhoto] Checkout blocked while uploads are in progress");
      pushUploadError(error, {
        phase: "checkout_blocked_upload_in_progress",
        productId: productID,
        productType,
        variantId: variantID,
        collectionId: currentCollectionID,
        activeTusUploadsCount: activeTusUploads.size,
        ...extractErrorContext(error),
      });
      showValidationAlert(getUploadTranslation("uploadInProgress", "Please wait until all photos are uploaded"));
      return;
    }

    const missingRequiredBlocks = getMissingRequiredUploadBlocks();
    if (missingRequiredBlocks.length > 0) {
      const error = new Error("[uploadPhoto] Checkout blocked because required uploads are missing");
      pushUploadError(error, {
        phase: "checkout_blocked_missing_required_uploads",
        productId: productID,
        productType,
        variantId: variantID,
        collectionId: currentCollectionID,
        missingRequiredBlocks: missingRequiredBlocks.join(","),
        missingRequiredBlockCount: missingRequiredBlocks.length,
        uploadedBlockCount: Object.keys(store).length,
        ...extractErrorContext(error),
      });
      showValidationAlert(getUploadTranslation("requiredPhotos", "Please upload all required photos"));
      return;
    }

    setCartProperties();
    addToCart();
  });
}

/* Initialize everything */
initOpenDialogButtons();
